import {State} from "./types";
import {setRequestStatus} from "../request-status";
import {chartsInitialState} from "global/initial-states";

export const initialState: State = {
  charts: chartsInitialState,
  request: {
    charts: setRequestStatus("initial"),
  },
};
